import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';
import { Nullable } from '@client/core/data/types';

export class Pagination {
  constructor(
    public readonly currentPage: number,
    public readonly lastPage: number,
    public readonly perPage: number,
    public readonly from: Nullable<number>,
    public readonly to: Nullable<number>,
    public readonly total: number,
  ) {}
}

defineTransform(Pagination, (json) => {
  return {
    currentPage: json.current_page,
    perPage: json.per_page,
    lastPage: json.last_page,
  };
});
